<template>
    <div class="shop-main">
        <!-- 头部 -->
        <headers></headers>
        <div v-if="langluageType == 'ch'">
            <section class="ban-bg">
            </section>
            <section class="ban">
                <div class="col">
                </div>
            </section>
            <div>
                <section class="col" style="padding-top: 100px;">
                    <div class="shop-title">
                        <h4 style="font-size: 34px;color: #333333;">标准展台装修</h4>
                    </div>
                    <div class="shop-list1">
                        <a href="javascript:;">
                            <img src="../images/shop/img9.jpg" alt="">
                        </a>
                        <a href="javascript:;">
                            <img src="../images/shop/img10.jpg" alt="">
                        </a>
                    </div>
                </section>
                <section class="col" style="padding-top: 100px;">
                    <div class="shop-title">
                        <h4 style="font-size: 34px;color: #333333;">展台印刷品、礼品</h4>
                    </div>
                    <ul class="shop-list2">
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img1.jpg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img2.jpg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img3.jpg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img4.jpg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img5.jpg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img6.jpg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img7.jpg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img8.png" alt="">
                            </a>
                        </li>
                    </ul>
                </section>
                <h4 class="title3" style="margin-bottom: 30px;margin-top: 100px;font-size: 34px;color: #333333;">服务联系</h4>
                <div class="box-fwlx">
                    <section class="col box-3 ">
                        <div class="box-fwlx-con">
                            <div class="div1">
                                <p >联系我们</p>
                                <img  src="../images/333.png" alt="">
                                <p>印刷咨询客服（工作日9:00-18:00）</p>
                                <span>010-86460766-806</span>
                            </div>
                            
                                <ul class="ul1">
                                    <form id="form-zx2" action="">
                                        <li class="li1">
                                            <label for="">公司名称</label>
                                            <input name="compnay" type="text" maxlength="50">
                                        </li>
                                        <li class="li1">
                                            <label for="">您的称呼</label>
                                            <input name="username" type="text" maxlength="20">
                                        </li>
                                        <li class="li1">
                                            <label for="">电话</label>
                                            <input name="phone" type="text">
                                        </li>
                                        <li class="li1">
                                            <label for="">邮箱</label>
                                            <input name="industry" type="text" maxlength="30">
                                        </li>
                                        <li>
                                            <label for="">咨询需求</label>
                                            <textarea name="content" id="" maxlength="200"></textarea>
                                        </li>
                                        <li>
                                            <a class="btn" id="btn-zx-sub2" href="javascript:;">立即发送</a>
                                        </li>
                                    </form>
                                </ul>
                            
                        </div>
                    </section>
                </div>
            </div>
        </div>
        <div v-else>
            <section class="ban-bg">
            </section>
            <section class="ban bgcImg"  style="background-size: cover !important;">
                <div class="col">
                </div>
            </section>
            <div>
                <section class="col" style="padding-top: 100px;">
                    <div class="shop-title">
                        <h4 style="color: #333333;font-size: 30px;">Standard booth decoration</h4>
                    </div>
                    <div class="shop-list1">
                        <a href="javascript:;">
                            <img src="../images/shop/img9-1.png" alt="">
                        </a>
                        <a href="javascript:;">
                            <img src="../images/shop/img10-1.png" alt="">
                        </a>
                    </div>
                </section>
                <section class="col" style="padding-top: 100px;">
                    <div class="shop-title">
                        <h4 style="color: #333333;font-size: 30px;">Booth prints and gifts</h4>
                    </div>
                    <ul class="shop-list2">
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img1.jpg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img2.jpg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img3.jpg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img4.jpg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img5.jpg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img6.jpg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img7.jpg" alt="">
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <img src="../images/shop/img8.png" alt="">
                            </a>
                        </li>
                    </ul>
                </section>
                <div style="background-color: #F9FAFB;margin-top: 123px;">
                    <section class="col box-3">
                        <h4 class="title3" style="margin-bottom: 50px;font-size: 30px;color: #333333;">Service advantages and guarantees</h4>
                        <ul class="list8">
                            <li><img src="../images/icon-4-1.png" alt="" style="width: 88px;height: 88px;"><p style="font-size: 14px;">Advanced management concept</p></li>
                            <li><img src="../images/icon-4-2.png" alt="" style="width: 88px;height: 88px;"><p style="font-size: 14px;">Perfect service guarantee system</p></li>
                            <li><img src="../images/icon-4-3.png" alt="" style="width: 88px;height: 88px;"><p style="font-size: 14px;">Extensive service network</p></li>
                            <li><img src="../images/icon-4-4.png" alt="" style="width: 88px;height: 88px;"><p style="font-size: 14px;">Professional and efficient team</p></li>
                            <li><img src="../images/icon-4-5.png" alt="" style="width: 88px;height: 88px;"><p style="font-size: 14px;">Professional and efficient team</p></li>
                        </ul>
                    </section>
                </div>
                <h4 class="title3" style="margin-bottom: 30px;margin-top: 100px;color: #333333;font-size: 30px;">Service contact</h4>
                <div class="box-fwlx">
                    <section class="col box-3 ">
                        <div class="box-fwlx-con">
                            <div class="div1">
                                <p>WeChat Service</p>
                                <img src="../images/secCode.png" alt="">
                                <p>Chief Customer Service Hotline</p>
                                <span>010-86460766-861</span>
                            </div>
                            
                                <ul class="ul1">
                                    <form id="form-zx2" action="">
                                        <li class="li1">
                                            <label for="">Company name</label>
                                            <input name="compnay" type="text" maxlength="50">
                                        </li>
                                        <li class="li1">
                                            <label for="">industry</label>
                                            <input name="industry" type="text" maxlength="30">
                                        </li>
                                        <li class="li1">
                                            <label for="">Your name</label>
                                            <input name="username" type="text" maxlength="20">
                                        </li>
                                        <li class="li1">
                                            <label for="">Mobile phone number</label>
                                            <input name="phone" type="text">
                                        </li>
                                        <li>
                                            <label for="">Consulting demand</label>
                                            <textarea name="content" id="" maxlength="200"></textarea>
                                        </li>
                                        <li>
                                            <a class="btn" id="btn-zx-sub2" href="javascript:;">Send Now</a>
                                        </li>
                                    </form>
                                </ul>
                            
                        </div>
                    </section>
                </div>
            </div>
        </div>
         <!-- 尾部 -->
        <footers></footers>
        <!-- 右侧吸附客服咨询按钮 -->
        <contact></contact>
        
    </div>
</template>
    <script>
        import headers from '@/common/header';
    import footers from '@/common/Footer';
    import contact from '@/components/contact';
    export default {
        components: {
            headers,
            footers,
            contact
        },
        data(){
            return {
                langluageType:sessionStorage.getItem('langluageType')||'ch',
            }
        }
    }
            
    </script>
    <style scoped>
    .bgcImg {
        background: url(../images/shop/img11-1-1-1.png) center !important;
    }
    </style>


// WEBPACK FOOTER //
// src/page/shop.vue